/* bf G4 – Exit-Intent-Layer.
   Desktop: Maus verlaesst das Fenster nach oben (fruehestens nach X Sekunden).
   Mobil: nach X Sekunden, aber nicht solange Warenkorb, Menue oder ein anderer Dialog offen ist.
   Wartet, bis das Cookie-Banner beantwortet ist (Shopify Customer Privacy API).
   Merken: mit Einwilligung "Praeferenzen" in localStorage fuer X Tage, sonst in sessionStorage (eine Sitzung).
   Ist "Ohne Einwilligung einmal pro Sitzung" aus, erscheint der Layer ohne Einwilligung gar nicht.
   Im Theme-Editor nie automatisch, nur wenn die Section ausgewaehlt ist. */
if (!customElements.get('bf-exit-intent')) {
  const KEY = 'bf-exit-intent'
  const DONE = 'bf-newsletter-done'

  const store = {
    sessionOk: true,
    persistAllowed () {
      try {
        const cp = window.Shopify && window.Shopify.customerPrivacy
        return !!(cp && typeof cp.preferencesProcessingAllowed === 'function' && cp.preferencesProcessingAllowed())
      } catch (e) { return false }
    },
    get (key) {
      let value = null
      try { value = window.sessionStorage.getItem(key) } catch (e) {}
      if (value === null && this.persistAllowed()) {
        try { value = window.localStorage.getItem(key) } catch (e) {}
      }
      return value
    },
    set (key, value) {
      const persist = this.persistAllowed()
      if (persist || this.sessionOk) {
        try { window.sessionStorage.setItem(key, value) } catch (e) {}
      }
      if (persist) {
        try { window.localStorage.setItem(key, value) } catch (e) {}
      }
    }
  }

  class BfExitIntent extends HTMLElement {
    connectedCallback () {
      this.dialog = this.querySelector('dialog')
      if (!this.dialog) return
      this.sectionId = this.dataset.sectionId
      this.design = this.hasAttribute('data-design-mode')
      this.started = Date.now()
      this.armed = false
      store.sessionOk = this.dataset.session !== 'false'

      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-bf-exit-close]')) this.close()
        else if (e.target === this.dialog) this.close()
      })
      this.dialog.addEventListener('cancel', (e) => { e.preventDefault(); this.close() })
      this.dialog.addEventListener('close', () => document.documentElement.classList.remove('bf-exit-open'))

      document.addEventListener('bf:newsletter:success', () => store.set(DONE, '1'))

      if (this.design) { this.setupEditor(); return }
      if (this.suppressed()) return
      this.waitForConsent(() => this.arm())
    }

    disconnectedCallback () {
      this.disarm()
      if (this.onSelect) {
        document.removeEventListener('shopify:section:select', this.onSelect)
        document.removeEventListener('shopify:section:deselect', this.onDeselect)
      }
    }

    suppressed () {
      // R64: gerade angemeldet (Seite nach dem Absenden, ?customer_posted=true) -> nicht mehr anbieten
      if (window.bfNewsletterPosted || /[?&]customer_posted=true(&|$)/.test(window.location.search)) {
        store.set(DONE, '1')
        return true
      }
      if (store.get(DONE)) return true
      const raw = store.get(KEY)
      if (!raw) return false
      const days = parseInt(this.dataset.days, 10) || 14
      const ts = parseInt(raw, 10)
      if (!ts) return true
      return Date.now() - ts < days * 864e5
    }

    waitForConsent (cb) {
      let done = false
      const go = () => { if (!done) { done = true; cb() } }
      const decided = () => {
        try {
          const cp = window.Shopify && window.Shopify.customerPrivacy
          if (!cp || typeof cp.shouldShowBanner !== 'function') return true
          if (!cp.shouldShowBanner()) return true
          const c = typeof cp.currentVisitorConsent === 'function' ? cp.currentVisitorConsent() : null
          return !!(c && c.preferences !== '' && c.preferences !== undefined)
        } catch (e) { return true }
      }
      const check = () => { if (decided()) go(); else document.addEventListener('visitorConsentCollected', go, { once: true }) }
      if (window.Shopify && window.Shopify.customerPrivacy) { check(); return }
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        const timer = window.setTimeout(go, 4000)
        try {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => {
            window.clearTimeout(timer)
            if (err) go(); else check()
          })
        } catch (e) { window.clearTimeout(timer); go() }
        return
      }
      go()
    }

    arm () {
      if (this.armed) return
      if (!store.sessionOk && !store.persistAllowed()) return
      this.armed = true
      const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches
      if (fine && this.dataset.desktop === 'true') {
        const min = (parseInt(this.dataset.desktopMin, 10) || 0) * 1000
        this.onLeave = (e) => {
          if (e.relatedTarget || e.clientY > 10) return
          if (Date.now() - this.started < min) return
          this.tryOpen()
        }
        document.addEventListener('mouseout', this.onLeave)
      } else if (!fine && this.dataset.mobile === 'true') {
        const delay = (parseInt(this.dataset.mobileDelay, 10) || 40) * 1000
        this.timer = window.setTimeout(() => this.tryOpen(true), delay)
      }
    }

    disarm () {
      if (this.onLeave) document.removeEventListener('mouseout', this.onLeave)
      if (this.timer) window.clearTimeout(this.timer)
      this.onLeave = null
      this.timer = null
    }

    busy () {
      const html = document.documentElement
      if (html.classList.contains('bf-cart-open') || html.classList.contains('bf-sticky-open')) return true
      if (document.body.classList.contains('js-drawer-open') || document.body.classList.contains('js-drawer-open-left')) return true
      if (document.querySelector('dialog[open]')) return true
      const active = document.activeElement
      if (active && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName)) return true
      return document.visibilityState !== 'visible'
    }

    tryOpen (retry) {
      if (this.suppressed()) { this.disarm(); return }
      if (this.busy()) {
        if (retry) this.timer = window.setTimeout(() => this.tryOpen(true), 15000)
        return
      }
      this.disarm()
      store.set(KEY, String(Date.now()))
      this.open()
    }

    open () {
      if (this.dialog.open) return
      document.documentElement.classList.add('bf-exit-open')
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal()
      else this.dialog.setAttribute('open', '')
    }

    close () {
      if (typeof this.dialog.close === 'function' && this.dialog.open) this.dialog.close()
      else this.dialog.removeAttribute('open')
      document.documentElement.classList.remove('bf-exit-open')
    }

    setupEditor () {
      this.onSelect = (e) => { if (e.detail && e.detail.sectionId === this.sectionId) this.open() }
      this.onDeselect = (e) => { if (e.detail && e.detail.sectionId === this.sectionId) this.close() }
      document.addEventListener('shopify:section:select', this.onSelect)
      document.addEventListener('shopify:section:deselect', this.onDeselect)
    }
  }

  customElements.define('bf-exit-intent', BfExitIntent)
}
